import { z } from 'zod'

/**
 * OCR スタンプ獲得失敗時（400）のレスポンスボディ
 */
export const OcrStampAcquireErrorBodySchema = z.object({
  ocrId: z.number().nullable().optional(),
  code: z.string().optional(),
})
export type OcrStampAcquireErrorBody = z.infer<typeof OcrStampAcquireErrorBodySchema>

/**
 * OCR 補填申請リクエストボディ
 */
export const OcrScanRequestSchema = z.object({
  ocrId: z.number().nullable(),
  message: z.string().optional(),
  fields: z.record(z.string(), z.string()).optional(),
})
export type OcrScanRequest = z.infer<typeof OcrScanRequestSchema>
